import { Popover } from '@mui/material';

import type { Doc } from 'src/@types/docs.js';
import { ImagePickerUpload } from 'src/components/ImagePickerUpload';
import { useUpdateDocMutation } from '../useUpdateDocMutation';
import { useCategories } from './constants';

type Props = {
  doc: Doc;
  target: null | React.MouseEvent['currentTarget'];
  handleClose: () => void;
};

export const CoverPickerPopOver = ({ doc, target, handleClose }: Props) => {
  const { updateDoc } = useUpdateDocMutation();
  const categories = useCategories();

  const open = Boolean(target);

  const handleImageSelect = async (value: string, type: 'color' | 'custom') => {
    if (doc?.cover?.value === value) {
      handleClose();
      return;
    }
    await updateDoc({
      _id: doc?._id,
      cover: {
        type,
        value,
      },
    });
    handleClose();
  };

  return (
    <Popover
      open={open}
      anchorEl={target}
      onClose={handleClose}
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'left',
      }}
      transformOrigin={{
        vertical: 'top',
        horizontal: 'left',
      }}
      slotProps={{
        paper: {
          sx: { p: 1 },
        },
      }}
    >
      <ImagePickerUpload
        handleImageSelect={handleImageSelect}
        categories={categories}
      />
    </Popover>
  );
};
